import { ObservationPhotoDialog } from "./components/ObservationPhotoDialog";

export default ObservationPhotoDialog;